
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.955,"time":57300,"words":191}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Housekeeper is represented by a tall red meeple and is used to provide service in support of all dining `}<a parentName="p" {...{
        "href": "/term/activity"
      }}>{`activities`}</a>{` and as a backup lady’s maid. Such service would primarily be coordinating meals through her management of the food and kitchen.`}</p>
    <div className="flavor-text">
      <p>{`The Housekeeper was the highest ranking female servant and quite accomplished. She was in charge of the female staff (maids and kitchen staff) as well as all accommodations for both the female and male staff (living quarters). She managed the household accounts and paid tradesmen for their services. She also ensured that the house was clean, an enormous task given the staggering size of many country houses.`}</p>
    </div>
    <p>{`Due to her responsibility for estate provisions and all staff in the kitchen, the Housekeeper is the required servant for meals in the breakfast room and formal dinners in the dining rooms. The Housekeeper may also function as a lady’s maid when shorthanded, but only if a lady’s maid is unavailable. Like the `}<a parentName="p" {...{
        "href": "butler"
      }}>{`butler`}</a>{` and underbutler, she is a loyal servant who cannot be lured away by another player (via the butler’s room recruit action).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Housekeeper"
}

